import initialState from "./initialState";

export const OosSearchReducer = (
  state = initialState.oosSearchCriteria,
  action
) => {
  switch (action.type) {
    case "OOS_SEARCH_FORM_DATA":
      return action.payload;

    default:
      return state;
  }
};
